<template>
  <a-spin :spinning="formOption.busy">

    <a-form :form="form"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
    >

      <div class="form_title">规则设置</div>
      <div><h3 style="display: inline-block">自动打标签</h3>
        <a-switch
            v-model="isAutoTag"
            checked-children="是"
            un-checked-children="否"
            style="margin: -8px 10px 0"
        />
        开启此功能后，当满足标签规则时自动为该用户打上标签
      </div>
      <div v-for="(item,index) in tagRuleList" :key="item.tagRuleId" v-show="isAutoTag">
        <div class="rule-item">
          <h3>规则{{ index + 1 }}:</h3>
          <a-select v-model="item.ruleId" :options="ruleTypeOptions" style="width: 200px"></a-select>
          <template v-if="item.ruleId === 1"><span></span></template>
          <template v-if="item.ruleId === 2">
            <span>达到</span>
            <a-input v-model="item.ruleCondition" style="width: 80px"></a-input>
            <span>人</span>
          </template>
          <template v-if="item.ruleId === 3">
            <span>等级</span>
            <a-select v-model="item.ruleCondition" :options="labelOptions" style="width: 200px"></a-select>
            <span>时</span>
          </template>
          <!--          <a-select-->
          <!--              mode="multiple"-->
          <!--              v-model="item.tagIds"-->
          <!--              :options="tagOptions"-->
          <!--              style="width: 300px"-->
          <!--              @change="handleChange"-->
          <!--          >-->
          <!--          </a-select>-->
          <tagPicker v-model="item.tagId"></tagPicker>
          <a-icon type="plus-circle" @click="add(index,item)"/>
          <a-icon type="minus-circle" @click="delItem(index,item)"/>
        </div>
      </div>
    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="lastStep">上一步</a-button>
      <a-button type="primary" @click="submit">下一步</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin, fmt} from '@/utils/common/FormBase'
import {dataApi} from "@/services/operate/marketingFission";
import tagPicker from '@/components/picker/scrmTagPicker.vue';

/**
 * 加载规则 必填控制我
 */
function getRulesTemplate() {
  return {
    content: {
      rules: [{required: true, message: "请输入欢迎语内容"}]
    }
  };
}


/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    isAutoTag: true
  };
}


/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {

  let entity = await dataApi.getFormDetail(rowId);
  this.detail = entity.data
  this.labelOptions = entity.data.prizeList.map(item => {
    return {
      title: item.prizeRank,
      key: item.prizeId
    }
  })
  this.isAutoTag = entity.data.isAutoTag === 1
  if (entity.data.tagRuleList.length > 0) {
    this.tagRuleList = entity.data.tagRuleList
  }
  return fmt.formatFormLoad(entity);
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
async function afterLoad(entity) {
  console.log(entity)
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function submit() {
  const vm = this
  if (this.isAutoTag) {
    let params = this.detail
    params.isAutoTag = 1
    let flag = true
    this.tagRuleList.every(item => {
      if (item.tagId === '') {
        this.$message.error('请选择标签')
        flag = false
        return false
      }
    })
    if (flag) {
      params.addRuleList = this.tagRuleList.map((item, index) => {
        item.orderNum = index
        if (item.ruleId === 3) {
          item.prizeId = item.ruleCondition
        }
        return item
      })
      params.delRuleList = vm.delRuleList
      await dataApi.saveFormDetail(params).then(res => {
        if (res.code === 200) {
          this.$emit('nextStep', res.data.fissionId)
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  } else {
    let params = this.detail
    params.isAutoTag = 0
    await dataApi.saveFormDetail(params).then(res => {
      if (res.code === 200) {
        this.$emit('nextStep', res.data.fissionId)
      } else {
        this.$message.error(res.msg)
      }
    })
  }
}

/**
 * 加载基础数据
 */
async function loadBaseData() {
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {tagPicker},
  data() {
    return {
      isAutoTag: true,
      tagRuleList: [{ruleId: 1, fissionId: this.rowId, tagId: '', ruleCondition: ''}],
      delRuleList: [],
      ruleTypeOptions: [{title: '全部用户', key: 1}, {title: '助力人数', key: 2}, {title: '达成阶梯', key: 3}],
      labelOptions: [],
      tagOptions: [],
      detail: null
    }
  },
  mounted() {
    console.log(this.rowId)
  },
  methods: {
    loadEntity,
    newEntity,
    submit,
    getRulesTemplate,
    afterLoad,
    loadBaseData,
    add(index) {
      const item = {ruleId: 1, fissionId: this.rowId, tagId: '', ruleCondition: ''}
      this.tagRuleList.splice(index + 1, 0, item)
    },
    delItem(index, item) {
      if (this.tagRuleList.length <= 1) {
        this.$message.error('请至少填写一条规则')
        return false
      }
      if (item.tagRuleId) {
        this.delRuleList.push(item.tagRuleId)
      }
      this.tagRuleList.splice(index, 1)
    },
    lastStep() {
      this.$emit('lastStep')
    },
    handleChange() {
      this.$forceUpdate()
    }
  }
};
</script>
<style lang="less" scoped>
.rule-item {
  display: flex;
  margin-top: 12px;
  line-height: 30px;

  h3 {
    width: 60px;
  }

  span {
    display: inline-block;
    width: 60px;
    text-align: center;
  }

  i {
    font-size: 24px;
    margin-left: 12px;
    color: #D90B18;
    cursor: pointer;
  }
}
</style>
